"use client";

import { Button } from "@/components/ui/button";

/** The see-through button look used on the brand-coloured field of the error pages. */
const ERROR_GHOST_CLASS = "border-brand-foreground/40 bg-transparent text-brand-foreground hover:bg-brand-foreground/15 hover:text-brand-foreground";

/** The "go back" button of the 404 page: one step back in the browser history. */
export function ErrorBackButton({ label }: { label: string }) {
  return <Button variant="outline" className={ERROR_GHOST_CLASS} onClick={() => window.history.back()}>{label}</Button>;
}
